import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import { sortDataByOrder } from "../../utils/helper";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import CardList from "./newUx/CardList/CardList";

const color = ["#E75E0D", "#EB9F11", "#ABC710", "#009340", "#CC0370", "#8366A9", "#149BD7"];

export default function WhyWork() {
  const navigate = useNavigate();
  const localData = useSelector((state) => state?.localStorage)
  const { micrositeID, tabConfigId } = localData
  const [loading, setLoading] = useState(true);

  const [activeKey,] = useState("why-work");
  const [responseData, setReponseData] = useState([]);
  const id = micrositeID

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mediatype, setmediatype] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [, setAlertModal] = useState(false);

  const getWhyWork = async (activeKey, id) => {
    try {
      setLoading(true);
      if (id) {
        const response = await getRequest(
          userapiservice.getMicrositeDetailsTabs(id, tabConfigId),
          null,
          false
        );
        setReponseData(sortDataByOrder(response));
        setLoading(false);
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || error?.message || 'Sorry, Something went wrong'} />)
      setLoading(false);
    }
  };

  const PlayVideoHandler = (url, mediaType) => {
    setmediatype(mediaType);
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  const convertToStandardURL = (shortUrl) => {
    if (shortUrl?.indexOf("youtu.be") !== -1) {
      const video_id = shortUrl?.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/watch?v=${video_id}`;
    }
    return shortUrl;
  };

  const onCardClickHandler = (data) => {
    // console.log("data:", data)
    if (data.description?.length > 0) {
      navigate(`/microsite/${data.id}/micrositeDetails`, {
        state: { page: activeKey, data: data },
      });
    } else {
      setAlertModal(true);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };

  useEffect(() => {
    getWhyWork(activeKey, id);
  }, [activeKey, id]);

  if (loading) {
    return (
      <div
        className="ant-tabs-content-holder"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="loader">
          <Spin tip="Loading" size="large" />
        </div>
      </div>
    );
  } else {
    return (
      <CardList
        responseData={responseData}
        color={color}
        PlayVideoHandler={PlayVideoHandler}
        convertToStandardURL={convertToStandardURL}
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
        videoUrl={videoUrl}
        mediaType={mediatype}
        onCardClickHandler={onCardClickHandler}
      />

    );
  }
}
